<template>
  <el-form ref="form" :model="form" :rules="formRules" class="form_flex">
    <el-form-item prop="userId">
      <el-select
        class="select"
        v-model="form.userId"
        filterable
        remote
        placeholder="请输入用户名"
        :remote-method="searchUser"
        clearable
        :loading="loading"
      >
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </el-form-item>

    <el-form-item class="btn">
      <el-button
        @click="$emit('search', form.userId)"
        icon="el-icon-search"
        size="small"
        >查询</el-button
      >
      <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
        >刷新</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import { getUserModelApi } from '@/api/user.js';
import { decrypt } from '@/utils/encryp';
export default {
  name: 'feedBackSearchBar',
  inject: ['reload'], // 注入reload方法
  data() {
    return {
      // 表单内容
      form: {
        userId: '',
      },
      userName: '',
      loading: false,
      options: null,
      formRules: {
        userId: [
          { required: true, message: '用户名不能为空', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    // 搜索用户
    async searchUser(val) {
      this.loading = true;
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      let res = await getUserModelApi({ userName: val, areaId });
      this.loading = false;
      console.log('userId', this.form.userId, this.userName);
      this.options = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    // 点击状态下拉数据
    changeRole(val) {
      this.form.status = val;
    },

    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 清空表单
    resetForm() {
      this.$refs['form'].resetFields();
    },
  },
};
</script>

<style lang="less" scoped>
.form_flex {
  display: flex;
}

.search-select {
  width: 120px;
  margin-right: 10px;
}

button {
  height: 40px;
  margin-left: 10px;
}

.msg-input {
  width: 330px;
  margin-left: 10px;
}

/deep/ .el-form-item__content {
  display: flex;
}
</style>
